/*
 * Centralized scroll animation handler.
 * Reads data-scroll-animation on section wrappers and applies the right effect.
 *
 * Supported values:
 *   parallax     - background media translates at a fraction of scroll speed
 *   fade-up      - fades + slides up when entering viewport
 *   sticky-stack - section pins to top of viewport while next section scrolls over it
 *
 * Optional data attributes:
 *   data-scroll-animation-strength   (parallax: 10-60, percent as decimal)
 *   data-scroll-animation-target     (CSS selector of element to animate, defaults below)
 *   data-scroll-animation-once       ('true' to fire once and disconnect; default true for fade-up)
 */
(function () {
  if (window.__destaniyaScrollAnimationsInit) return;
  window.__destaniyaScrollAnimationsInit = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  // ─── PARALLAX ────────────────────────────────────────────────────────────
  function initParallax(container) {
    if (reduceMotion) return;
    var targetSelector =
      container.getAttribute('data-scroll-animation-target') ||
      '.scroll-animation__target, .hero__media-grid, .featured-product__media, picture, video, img';
    var media = container.querySelector(targetSelector);
    if (!media) return;

    var strength = parseFloat(container.getAttribute('data-scroll-animation-strength'));
    if (isNaN(strength) || strength <= 0) strength = 0.25;

    var ticking = false;
    var lastOffset = 9999;

    function update() {
      ticking = false;
      var rect = container.getBoundingClientRect();
      var wh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < -50 || rect.top > wh + 50) return;
      var containerCenter = rect.top + rect.height / 2;
      var viewportCenter = wh / 2;
      var distance = containerCenter - viewportCenter;
      var offset = -distance * strength;
      if (Math.abs(offset - lastOffset) < 0.5) return;
      lastOffset = offset;
      media.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          each(entries, function (entry) {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', onScroll, { passive: true });
              window.addEventListener('resize', onScroll, { passive: true });
              update();
            } else {
              window.removeEventListener('scroll', onScroll);
              window.removeEventListener('resize', onScroll);
            }
          });
        },
        { rootMargin: '100px' }
      );
      io.observe(container);
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    update();
  }

  // ─── FADE-UP ON ENTRY ───────────────────────────────────────────────────
  function initFadeUp(container) {
    if (reduceMotion) {
      container.classList.add('scroll-animation--visible');
      return;
    }
    if (!('IntersectionObserver' in window)) {
      container.classList.add('scroll-animation--visible');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        each(entries, function (entry) {
          if (entry.isIntersecting) {
            container.classList.add('scroll-animation--visible');
            io.unobserve(container);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    io.observe(container);
  }

  // ─── STICKY STACK ────────────────────────────────────────────────────────
  // Pure CSS via class — JS only marks the section so styles apply
  function initStickyStack(container) {
    container.classList.add('scroll-animation--sticky-stack-active');
  }

  // ─── INIT ────────────────────────────────────────────────────────────────
  function initAll() {
    each(document.querySelectorAll('[data-scroll-animation]'), function (el) {
      var type = el.getAttribute('data-scroll-animation');
      if (!type || type === 'none') return;
      if (el.dataset.scrollAnimationInit === 'true') return;
      el.dataset.scrollAnimationInit = 'true';

      if (type === 'parallax') initParallax(el);
      else if (type === 'fade-up') initFadeUp(el);
      else if (type === 'sticky-stack') initStickyStack(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify section is reloaded in editor
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (e) {
    // No teardown needed since IO is contained per element
  });
})();
